export async function init() {}

export function offer({ commit }, payload) {
	if (payload.event === 'created') {
		commit('auth/UPDATE_CURRENT_USER', {
			subscriptionStatus: 'pendingOffer',
		}, { root: true });
		commit('subscription/UPDATE_SUBSCRIPTION', {
			offer: payload.offer,
		}, { root: true });
	}
}

/**
 * @depricated
 */
export function importVehicleStatus({ dispatch }, payload) {
	const log = msg => dispatch('vehicle/setImportNotification', msg, { root: true });
	const progress = progress => dispatch('vehicle/setImportProgress', progress, { root: true });

	switch (payload.event) {
		case 'start':
			log('Der Import wurde gerade gestartet!');
			progress(null);
			break;
		case 'fetching':
			if (!payload.vehicles || !payload.fetched) {
				log('Der Import wurde gerade gestartet!');
				progress(null);
			} else {
				log(`Wir importieren gerade Fahrzeug ${payload.fetched} von ${payload.vehicles}`);
				progress(payload.fetched / payload.vehicles * 90);
			}
			break;
		case 'database':
			log(`Wir aktualliseren gerade Fahrzeug ${
				payload.deleted + payload.inserted + payload.updated
			} von ${payload.vehicles}`);
			progress((payload.deleted + payload.inserted + payload.updated) / payload.vehicles * 10 + 90);

			// Update vehicle state
			switch (payload.action) {
				case 'remove':
					dispatch('vehicle/removeVehicle', payload.vehicle, { root: true });
					break;
				case 'insert':
					dispatch('vehicle/insertVehicle', payload.vehicle, { root: true });
					break;
				case 'update':
					dispatch('vehicle/updateVehicle', payload.vehicle, { root: true });
					break;
			}
			break;
		case 'finished':
			log(`Der Import wurde gerade beendet. ${payload.vehicles} Fahrzeuge wurden aktuallisiert!`);
			progress(100);
			dispatch('vehicle/getVehicles', null, { root: true });
			dispatch('vehicle/getHistory', null, { root: true });
			break;
		case 'aborted':
			log(`Der Import wurde abgebrochen. ${payload.vehicles} Fahrzeuge wurden aktuallisiert!`);
			progress(100);
			dispatch('vehicle/getVehicles', null, { root: true });
			dispatch('vehicle/getHistory', null, { root: true });
			break;
	}
}
